import { Component, ViewChild } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { DxDashboardControlComponent } from 'devexpress-dashboard-angular/ui/dashboard-control';
import { TextBoxItemEditorExtension } from 'devexpress-dashboard/designer/text-box-item-editor-extension';
import { IconDefinition, faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-dashboard-component',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  //#region Fields & Icons
  dashBoardId: string;
  refreshInterval: number;
  viewerMode: boolean = false;
  subscription: Subscription;
  @ViewChild(DxDashboardControlComponent, { static: false }) dashboardControl: DxDashboardControlComponent;
  faArrowLeftLong: IconDefinition = faArrowLeftLong;
  //#endregion

  constructor() {
    if (!localStorage.getItem('qx_userId')) {
      window.location.href = '/signin';
      return;
    }

    if (!localStorage.getItem('qx_dashboard')) return;
    let dashboardData = JSON.parse(localStorage.getItem('qx_dashboard'));
    this.dashBoardId = dashboardData.dashboardId;
    this.refreshInterval = dashboardData.refreshInterval;    
    this.viewerMode = true;
    localStorage.removeItem('qx_dashboard');
    if (this.refreshInterval > 0) {
      this.subscription = interval(this.refreshInterval * 1000).subscribe(() => {
        this.dashboardControl.instance.refresh();
      });
    }
  }

  onBeforeRender(e: any): void {
    e.component.registerExtension(new TextBoxItemEditorExtension(e.component)); 
  }

  back(): void {
    localStorage.removeItem('qx_dashboard');
    window.location.href = '/base';
  }
}
